require('./lbaResource.scss');

const $inject = [];

const lbaResource = function () {
  return {
    restrict: 'A',
    scope:{
      settings: '<'
    },
    bindToController: true,
    controller: 'lbaResourceCtrl',
    controllerAs: 'vm',
    template: require('./lbaResource.html')
  }
};

lbaResource.$inject = $inject;

export default lbaResource;



// WEBPACK FOOTER //
// ./src/components/lbaResource/lbaResourceDir.js